export default __webpack_public_path__ + "static/media/toggledLogo.02322e27.svg";